import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import Card from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';
import {
  TEACHER_TRAINING_BASE,
  TEACHER_TRAINING_LOBBY_PATH,
  teacherTrainingHostPath,
  teacherTrainingLegacyPath,
  teacherTrainingManagePath,
  teacherTrainingPath,
} from '../../../config/contentRoutes';
import { getTrainingHostByOwnerUid } from '../../../utils/trainingHost';

const manageSections = [
  {
    id: 'lobby',
    title: '로비',
    description: '방문자에게 보이는 화면을 그대로 편집합니다.',
    icon: '🚪',
    path: TEACHER_TRAINING_LOBBY_PATH,
  },
  {
    id: 'ai-edutech',
    title: 'AI/에듀테크 연수',
    description: '내가 만든 연수 페이지(TSX·URL·PDF)를 등록하고 공유 기간을 설정합니다.',
    icon: '🤖',
    path: teacherTrainingManagePath('ai-edutech'),
  },
  {
    id: 'training-public',
    title: '연수 공개 목록',
    description: '방문자에게 보이는 연수·참고 자료 목록입니다.',
    icon: '📋',
    path: teacherTrainingPath('training-pages'),
    external: true,
  },
];

const TeacherTrainingManage: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [mySlug, setMySlug] = useState<string | null>(null);

  useEffect(() => {
    if (!currentUser?.uid) return;
    getTrainingHostByOwnerUid(currentUser.uid)
      .then((host) => setMySlug(host?.publicSlug ?? null))
      .catch((err) => console.error(err));
  }, [currentUser?.uid]);

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100%',
        padding: '24px',
        boxSizing: 'border-box',
        fontFamily: 'var(--font-family-primary)',
        backgroundColor: 'var(--Color-background-main)',
      }}
    >
      <div style={{ maxWidth: '960px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h1 style={{ margin: '0 0 8px', fontSize: '28px', fontWeight: 700, color: 'var(--Color-text-strong)' }}>
              내 연수 관리
            </h1>
            <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
              교사마다 `/teacher-training/h/주소` 형태의 공개 허브가 있습니다. 여기서 내 허브만 관리하세요.
            </p>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {mySlug ? (
              <Button variant="primary" size="medium" onClick={() => navigate(teacherTrainingHostPath(mySlug))}>
                내 공개 허브
              </Button>
            ) : (
              <Button variant="primary" size="medium" onClick={() => navigate(TEACHER_TRAINING_LOBBY_PATH)}>
                로비 만들기
              </Button>
            )}
            <Button variant="outline" size="medium" onClick={() => navigate(TEACHER_TRAINING_BASE)}>
              전체 허브 목록
            </Button>
            <Button variant="outline" size="medium" onClick={() => navigate(teacherTrainingLegacyPath())}>
              MARU 연수 (기존)
            </Button>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
          {manageSections.map((section) => (
            <Card
              key={section.id}
              padding="20px"
              borderRadius="16px"
              background="var(--Color-background-normal)"
              style={{ cursor: 'pointer', height: '100%' }}
              onClick={() => navigate(section.path)}
            >
              <div style={{ fontSize: '32px', marginBottom: '12px' }}>{section.icon}</div>
              <h2 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
                {section.title}
              </h2>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
                {section.description}
              </p>
              {section.external && (
                <span style={{ display: 'inline-block', marginTop: '12px', fontSize: '13px', color: 'var(--Color-fill-brand-color)' }}>
                  공개 페이지로 이동 →
                </span>
              )}
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeacherTrainingManage;
